<template>
<div>
  <h1 class="title grey--text">编辑价格</h1>
  <div class="subheader">{{programInfo.title}}</div>
  <v-card flat class="my-5">
    <v-layout class="flex-column align-center">
      <v-flex v-for="(packageForPurchase, index) in programInfo.packagesForPurchase" v-bind:key="index" style="width:550px;">
        <y-program-package-for-purchase
          :programProperties="programProperties"
          :packageForPurchase="packageForPurchase"
          :programPackageForPurchaseCategories="programPackageForPurchaseCategories"
          v-on:upsert="programPackageForPurchaseUpsert($event, index)"
          v-on:program-package-deleted="programInfo.packagesForPurchase.splice(index, 1)"
        />
      </v-flex>
    </v-layout>
    <v-fab-transition>
      <v-dialog
          v-model="dialogAddPackage"
          width="500"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              color='primary'
              fixed
              bottom
              right
            >
              <v-icon
                left
                dark
              >
                add
              </v-icon>
              新增
            </v-btn>
          </template>
          <v-card>
            <v-card-title class="headline">
              新增购买选项
            </v-card-title>

            <v-card-text>
              <v-layout row wrap>
                <v-form
                  ref="programForm"
                  v-model="ispackageForPurchaseNewFormVisiblyValid"
                  lazy-validation
                  class="fullwidth"
                  style="width:650px;"
                >
                  <v-card-text>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-text-field
                          label="所含课时总数"
                          :rules="rules.purchaseQuantityRules"
                          v-model="packageForPurchaseNew.quantity"
                          outline
                        ></v-text-field>
                        <v-text-field
                          label="总数量"
                          v-model="packageForPurchaseNew.initialInventoryQuantity"
                          outline
                        ></v-text-field>
                        <v-select
                          v-model="packageForPurchaseNew.categoryCode"
                          :items="programPackageForPurchaseCategories"
                          item-text="category"
                          item-value="code"
                          label="选择类型"
                          single-line
                          :rules="rules.purchaseCategoryCodeRules"
                        ></v-select>
                        <span v-if="packageForPurchaseNew.categoryCode && packageForPurchaseNew.quantity">
                          <v-switch
                            label="指定基础价格"
                            v-model="packageForPurchaseNew.customBaseHrIncome"
                          >
                          </v-switch>
                          <v-text-field
                            v-if="packageForPurchaseNew.customBaseHrIncome"
                            label="指定基础价格[元/小时]"
                            v-model="packageForPurchaseNew.baseHrIncomeYuan"
                            outline
                          ></v-text-field>
                          <v-btn
                            color="primary"
                            text
                            @click="autoPriceCalculation"
                          >
                            自动填写
                          </v-btn>
                        </span>
                        <v-text-field
                          label="名称"
                          :rules="rules.purchaseTitleRules"
                          v-model="packageForPurchaseNew.title"
                          outline
                        ></v-text-field>
                        <v-text-field
                          label="描述"
                          :rules="rules.purchaseDescriptionRules"
                          v-model="packageForPurchaseNew.description"
                          outline
                        ></v-text-field>
                        <v-text-field
                          label="价格(元)"
                          :rules="rules.purchasePriceRules"
                          v-model="priceYuan"
                          outline
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-form>
                <!-- <v-form
                  ref="programForm"
                  v-model="ispackageForPurchaseNewFormVisiblyValid"
                  lazy-validation
                  class="fullwidth"
                  style="width:650px;"
                >
                  <v-flex xs12>
                    <v-text-field
                      label="名称"
                      :rules="rules.purchaseTitleRules"
                      v-model="packageForPurchaseNew.title"
                      outline
                    ></v-text-field>
                    <v-text-field
                      label="描述"
                      :rules="rules.purchaseDescriptionRules"
                      v-model="packageForPurchaseNew.description"
                      outline
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs5 class="px-2">
                    <v-text-field
                      label="所含课时总数"
                      :rules="rules.purchaseQuantityRules"
                      v-model="packageForPurchaseNew.quantity"
                      outline
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs5 class="px-2">
                  <v-text-field
                    label="价格(元)"
                    :rules="rules.purchasePriceRules"
                    v-model="priceYuan"
                    outline
                  ></v-text-field>
                  </v-flex>
                  <v-select
                    v-model="packageForPurchaseNew.categoryCode"
                    :items="programPackageForPurchaseCategories"
                    item-text="category"
                    item-value="code"
                    label="选择类型"
                    single-line
                    :rules="rules.purchaseCategoryCodeRules"
                  ></v-select>
                </v-form> -->
              </v-layout>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="grey"
                text
                @click="dialogAddPackage = false"
              >
                取消
              </v-btn>
              <v-btn
                :disabled="!ispackageForPurchaseNewFormVisiblyValid"
                color="primary"
                @click="programPackageForPurchaseInsert"
              >
                新增
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
    </v-fab-transition>
  </v-card>
  <!-- display overlay on the whole page while loading -->
  <v-overlay :value="$store.state.queryingState">
    <v-progress-circular
      indeterminate
      color=""
    ></v-progress-circular>
  </v-overlay>
</div>
</template>

<script>
import {
} from 'lodash'
// import Vue from 'vue'
import ProgramService from '@/services/ProgramService'
import OrganizationService from '@/services/OrganizationService'
import YProgramPackageForPurchase from '../components/YProgramPackageForPurchase'
export default {
  components: {
    YProgramPackageForPurchase
  },
  watch: {
  },
  computed: {
    priceYuan: {
      set: function (priceYuan) {
        this.packageForPurchaseNew.priceFen = priceYuan * 100
      },
      get: function () {
        return this.packageForPurchaseNew.priceFen ? this.packageForPurchaseNew.priceFen / 100 : null
      }
    },
    programProperties () {
      return {
        organizationId: this.programInfo.organizationId,
        sessionModuleQuantity: this.programInfo.sessionModuleQuantity,
        moduleLengthMin: this.programInfo.moduleLengthMin
      }
    }
  },
  // created: function () {
  // },
  data () {
    return {
      programInfo: {
        programId: null,
        organizationId: null,
        tutorId: null,
        title: '',
        description: '',
        imgUrl: '',
        videoFileStorageId: null,
        imageFileStorageId: null,
        publishProgramCommonPropertyId: null,
        editProgramCommonPropertyId: null,
        programCommonPropertyId: null,
        moduleLengthMin: 45,
        sessionModuleQuantity: 2,
        maxStudentNumberPerSession: 5,
        trainingObjective: '',
        trainingApproach: '',
        targetStudent: '',
        prerequisite: '',
        entryStudentAgeMonthLowerLimit: 36,
        entryStudentAgeMonthUpperLimit: 72,
        totalModuleQuantity: 20,
        interimAdmission: true,
        descriptionDetail: '',
        statusCode: null,
        categoryCode: null,
        prerequisiteTags: [],
        targetStudentTags: [],
        objectiveTags: [],
        tags: [],
        packagesForPurchase: []
      },
      programPackageForPurchaseCategories: [],
      rules: {
        // general
        required: v => !!v || '必填',
        selectionRequired: v => (v.length !== 0) || '必填',
        objectSelectionRequired: v => !!v || '必填',
        // purchase
        purchaseTitleRules: [
          v => this.rules.required(v)
        ],
        purchaseDescriptionRules: [
          v => this.rules.required(v)
        ],
        purchaseQuantityRules: [
          v => this.rules.required(v),
          v => v * 1 === parseInt(v * 1, 10) || '须为整数'
        ],
        purchasePriceRules: [
          v => this.rules.required(v),
          v => v * 100 === parseInt(v * 100, 10) || '请输入正确格式'
        ],
        purchaseCategoryCodeRules: [
          v => this.rules.required(v)
        ],
        venueDescriptionRules: [
          v => this.rules.required(v)
        ],
        venueQuantityRules: [
          v => this.rules.required(v)
        ],
        venueStatusCodeRules: [
          v => this.rules.required(v)
        ],
        venuePercentageRules: [
          v => this.rules.required(v)
        ],
        classNameRules: [
          v => this.rules.required(v)
        ],
        classDescriptionRules: [
          v => this.rules.required(v)
        ]
      },
      dialogAddPackage: false,
      packageForPurchaseNew: {
        title: '',
        description: '',
        quantity: null,
        priceFen: null,
        categoryCode: null,
        customBaseHrIncome: false,
        baseHrIncomeYuan: null
      },
      ispackageForPurchaseNewFormVisiblyValid: false
    }
  },
  async beforeMount () {
    this.$store.dispatch('setQueryingState', true)
    this.programInfo = this.$store.state.route.params.programInfo
    this.programPackageForPurchaseCategories = await this.getProgramPackageForPurchaseCategories()
    this.$store.dispatch('setQueryingState', false)
  },
  // async mounted () {
  // },
  // updated: async function () {
  // },
  methods: {
    async getTutorsByOrganizationId (organizationId) {
      try {
        console.log('\n#getTutorsByOrganizationId start ... \norganizationId:', organizationId)
        const res = await ProgramService.getTutors({ organizationId })
        console.log('Tutor info received! res.data:', res.data)
        return res.data
      } catch (err) {
        return err.response.data
      }
    },
    async getProgramPackageForPurchaseCategories () {
      try {
        const res = await ProgramService.getProgramPackageForPurchaseCategories()
        console.log('getProgramPackageForPurchaseCategories received! response.data:', res.data)
        return res.data
      } catch (err) {
        return err.res.data
      }
    },
    programPackageForPurchaseUpsert (e, index) {
      console.log('programPackageForPurchaseUpsert: e:')
      console.log(e)
      this.programInfo.packagesForPurchase.splice(index, 1, e)
    },
    async programPackageForPurchaseInsert () {
      console.log('Insert package: ')
      const res = await ProgramService.programPackageForPurchaseUpsert({
        programPackageForPurchase: {
          quantity: this.packageForPurchaseNew.quantity,
          categoryCode: this.packageForPurchaseNew.categoryCode,
          description: this.packageForPurchaseNew.description,
          priceFen: this.packageForPurchaseNew.priceFen,
          programId: this.programInfo.id,
          title: this.packageForPurchaseNew.title,
          visibleToPublic: 1,
          initialInventoryQuantity: this.packageForPurchaseNew.initialInventoryQuantity
        }
      })
      console.log(res)
      this.programInfo.packagesForPurchase.push(res.data.data[0])
      this.dialogAddPackage = false
      this.packageForPurchaseNew = {
        title: '',
        description: '',
        quantity: null,
        priceFen: null,
        categoryCode: null,
        initialInventoryQuantity: null,
        customBaseHrIncome: false
      }
    },
    async autoPriceCalculation () {
      const res = await OrganizationService.getOrganizationPricePerSessionFen({
        organizationId: this.programInfo.organizationId,
        categoryCode: this.packageForPurchaseNew.categoryCode,
        sessionLengthMin: this.programInfo.sessionModuleQuantity * this.programInfo.moduleLengthMin,
        baseHrIncomeFen: this.packageForPurchaseNew.customBaseHrIncome ? this.packageForPurchaseNew.baseHrIncomeYuan * 100 : null
      })
      const pricePerSessionFen = res.data
      const calculatedTotalPriceFen = Math.round(this.packageForPurchaseNew.quantity / this.programInfo.sessionModuleQuantity * pricePerSessionFen)
      // console.log(`计算总价: ${calculatedTotalPriceFen}`)
      this.packageForPurchaseNew.priceFen = calculatedTotalPriceFen
      const category = this.programPackageForPurchaseCategories.find(obj => {
        return obj.code === this.packageForPurchaseNew.categoryCode
      })
      this.packageForPurchaseNew.title = `[${category.category}] - ${this.packageForPurchaseNew.quantity / this.programInfo.sessionModuleQuantity}次`
      this.packageForPurchaseNew.description = `${this.programInfo.moduleLengthMin * this.programInfo.sessionModuleQuantity}分钟/次(每次包含${this.programInfo.sessionModuleQuantity}课时)`
    }
    // methods that are not used in this view
    // async submit (programInfo, purchasePackageInfo, venueCompensationInfo, classInfo) {
    //   if (this.$refs.programForm.validate() && programInfo.tutor_id) { // the form element is marked as ref="form" and can be refered here
    //     this.showWait = true
    //     try {
    //       const response = await this.createProgram(programInfo, purchasePackageInfo, venueCompensationInfo, classInfo)
    //       this.showWait = false
    //       if (response.programId) {
    //         this.error = null
    //         this.$router.push({ name: 'programs' })
    //       } else {
    //         console.log('something went wrong in creating program')
    //       }
    //     } catch (error) {
    //       this.error = error.response.data.msg
    //       this.showWait = false
    //     }
    //   }
    // },
    // async createProgram (programInfo, purchasePackageInfo, venueCompensationInfo, classInfo) {
    //   try {
    //     const response = await ProgramService.createProgram({ programInfo: programInfo, purchasePackageInfo: purchasePackageInfo, venueCompensationInfo: venueCompensationInfo, classInfo: classInfo })
    //     console.log('create program finished! response.data:', response.data)
    //     return response.data
    //   } catch (err) {
    //     return err.response.data
    //   }
    // },
    // expandClassInfo () {
    //   this.classInfo.push({
    //     name: '',
    //     description: '',
    //     tutor_id: this.programInfo.tutor_id,
    //     status_code: 1
    //   })
    // },
    // spliceClassInfo (index) {
    //   this.classInfo.splice(index, 1)
    // },
    // expandVenueCompensationInfo () {
    //   this.venueCompensationInfo.push({
    //     description: '',
    //     quantity: null,
    //     percentage: '5',
    //     status_code: 1,
    //     freezing_fund_fen: this.venue_freezing_fund_fen
    //   })
    // },
    // spliceVenueCompensationInfo (index) {
    //   this.venueCompensationInfo.splice(index, 1)
    // },

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
